<template>
  <div>

    <!-- <div style="position: absolute; top: 20px; right: 10px;z-index:9999999">
      <img src="../assets/logo.png" alt="" style="width: 50px;">
    </div> -->
    <div v-if="!IsConfirmAge" id="confirm-age" class="container-fluit"
      style="height: 100vh; background: rgba(191, 191, 191, 0.3);">
      <div id="noticePopup" :class="IsUnder18 ? 'popup-dialog open' : 'popup-dialog'">
        <div class="popup-global"><a href="#!" @click="IsUnder18 = false" class="popup-close close"><span
              class="lnr lnr-cross">X</span></a>
          <div class="popup--content text-center">Xin lỗi bạn vì sự bất tiện này, vui lòng ghé thăm Website của chúng
            tôi khi bạn đã đủ 18 tuổi.</div>
        </div>
      </div>
      <a-row
        style="margin-left:unset!important;margin-right:unset!important;height: 90%; align-items: center;display:flex">
        <a-col :xs="0" :sm="0" :md="0" :lg="6"></a-col>
        <a-col :xs="24" :sm="24" :md="24" :lg="12">
          <div style="width:100%;height: 500;text-align:center;background: none;background-size: 100% 100% !important;"
            class=" animate__animated animate__bounceIn  animate__fast">
            <div class="position-relative">
              <section class="agegatefrm text-xs-center clearfix">
                <h1 class="logo">
                  <span>TỔNG CÔNG TY CỔ PHẨN<br>BIA - RƯỢU - NƯỚC GIẢI KHÁT SÀI GÒN</span><br><br>
                </h1>
                <a-space wrap>
                  <a-button type="button" @click="IsConfirmAge = true" class="confirmage_button">Tôi đã đủ 18
                    tuổi</a-button>
                  <a-button type="button" @click="IsUnder18 = true" class="confirmage_button open--popup">Tôi chưa đủ
                    18 tuổi</a-button>
                </a-space>
                <div class="intro-languages"><br>
                </div>
                <div class="agreetext animate__animated animate__pulse  animate__delay-1s text-khaki"><b>SABECO</b>
                  cam kết uống có trách
                  nhiệm. Đó là lý do tại
                  sao chúng tôi cần
                  phải đảm bảo rằng bạn đang ở trên tuổi uống bia rượu hợp pháp và bạn được phép về mặt pháp
                  lý để xem trang web này. Khi nhấn xác nhận "Tôi đã đủ 18 tuổi" đồng nghĩa với việc bạn xác
                  nhận mình trong độ tuổi uống bia rượu hợp pháp. Nếu chưa đủ tuổi uống bia rượu hợp pháp, xin
                  vui lòng ghé thăm trang của chúng tôi khi bạn đã đủ 18 tuổi.</div>
              </section>
            </div>
          </div>
        </a-col>
        <a-col :xs="0" :sm="0" :md="0" :lg="6"></a-col>
      </a-row>
    </div>
    <a-row v-else>
      <!-- <div style="position: absolute;">
        <img class="bg-tagline-mobile animate__animated animate__rubberBand animate__fast" src='../assets/banner.png' />
      </div> -->
      <div class="right_panel">
        <a-col :xs="24" :sm="24" :md="24" :lg="12">
          <!-- <a-row>
          <a-col :xs="24" :sm="24" :md="24" :lg="24">
            <img class="bg-logo animate__animated animate__rubberBand animate__fast" src='../assets/banner.png' />
          </a-col>
        </a-row> -->
          <a-row>
            <a-col :xs="24" :sm="24" :md="24" :lg="24" style="
    position: absolute;">
              <img class="bg-bottle animate__animated animate__tada  animate__faster" src='../assets/poster.png' />
            </a-col>
          </a-row>
        </a-col>
        <a-col style="z-index: 99999;" :xs="24" :sm="24" :md="24" :lg="12" class="panel_data animate__animated animate__fadeIn  animate__delay-1s">
          <a-row><a-col>
              <a-space wrap>
                <a-button type="button" @click="SelectMenu('Rules')"
                  :class="UserMenu == 'Rules' ? 'menu_button active' : 'menu_button'">THỂ LỆ</a-button>
                <a-button type="button" @click="SelectMenu('FirstPrize')"
                  :class="UserMenu == 'FirstPrize' ? 'menu_button active' : 'menu_button'">GIẢI NHẤT</a-button>
                <a-button type="button" @click="SelectMenu('SecondPrize')"
                  :class="UserMenu == 'SecondPrize' ? 'menu_button active' : 'menu_button'">GIẢI NHÌ</a-button>
                <a-button type="button" @click="SelectMenu('Reward')"
                  :class="UserMenu == 'Reward' ? 'menu_button active' : 'menu_button'">ĐỔI THƯỞNG</a-button>
              </a-space>

              <br />
              <br />
              <fish-card fluid style="border-radius: 10px;border: #bc193f 2px solid;min-height:580px">
                <div slot="header">{{ oMenuData.Title }}</div>
                <div v-if="UserMenu == 'Rules'" style="height:500px">
                  <img src="../assets/rule/r1.jpg" width="100%" />
                  <img src="../assets/rule/r2.jpg" width="100%" />
                  <img src="../assets/rule/r3.jpg" width="100%" />
                  <img src="../assets/rule/r4.jpg" width="100%" />
                  <img src="../assets/rule/r5.jpg" width="100%" />
                  <img src="../assets/rule/r6.jpg" width="100%" />
                  <img src="../assets/rule/r7.jpg" width="100%" />
                  <img src="../assets/rule/r8.jpg" width="100%" />
                </div>
                <div v-if="UserMenu == 'FirstPrize' || UserMenu == 'SecondPrize' || UserMenu == 'Reward'"
                  style="text-align: right;"><a-input-search v-model="searchText"
                    :placeholder="UserMenu == 'Reward' ? 'Tìm kiếm điểm đổi thưởng' : 'Tìm kiếm'" class="searchBox"
                    @change="onChangeSearch" /></div>
                <a-table v-if="UserMenu == 'FirstPrize' || UserMenu == 'SecondPrize'" rowKey="STT" size="small" bordered
                  :columns="PrizeColumn" :data-source="lstShow" :loading="isLoadingTBL" @change="handleTableChange"
                  :scroll="{ x: 500 }" :pagination='false'
                  :locale="{ emptyText: 'Không có dữ liệu', filterReset: 'Làm mới', filterConfirm: 'Ok' }">

                  <template slot="customRender" slot-scope="text">
                    <span v-if="searchText.trim() != ''">
                      <template v-for="(fragment, i) in text
                        .toString()
                        .split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))">
                        <mark v-if="fragment.toLowerCase() === searchText.toLowerCase()" class="highlight" :key="i">{{
                          fragment }}</mark>
                        <template v-else>{{ fragment }}</template>
                      </template>
                    </span>
                    <template v-else>
                      {{ text }}
                    </template>
                  </template>
                </a-table>
                <!-- :pagination="{ pageSize: 10, total: TotalCount }" -->
                <a-table v-if="UserMenu == 'Reward'" rowKey="Address" size="small" bordered :columns="RewardColumn"
                  :data-source="lstShow" :loading="isLoadingTBL" @change="handleTableChange" :scroll="{ x: 500 }"
                  :pagination='false'
                  :locale="{ emptyText: 'Không có dữ liệu', filterReset: 'Làm mới', filterConfirm: 'Ok' }">
                  <!-- <template slot="customRender" slot-scope="text">
              <span v-if="searchText.trim() != ''">
                <template v-for="(fragment, i) in text
                  .toString()
                  .split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))">
                  <mark v-if="fragment.toLowerCase() === searchText.toLowerCase()" class="highlight" :key="i">{{
                    fragment }}</mark>
                  <template v-else>{{ fragment }}</template>
                </template>
              </span>
              <template v-else>
                {{ text }}
              </template>
            </template> -->

                  <template slot="Address" slot-scope="text">
                    <b>{{ text }}</b>
                    <!-- <hr style="margin:0" /> -->
                    <!-- <a-row>
                    <a-col span="8">
                      <i>Liên hệ:</i> <a-button size="small" :href="'tel:' + record.OwnerPhone.replace(/\s/, '')"> <i
                          class="fa fa-phone" aria-hidden="true"></i>
                        <b>{{ formatPhoneNumber(record.OwnerPhone.replace(/\s/, '').trim()) }}</b></a-button>
                    </a-col>
                    <a-col span="16">
                      - <i>Người LH:</i> <b>{{ record.OwnerName }}</b>
                    </a-col>
                  </a-row> -->
                  </template>
                  <template slot="OwnerPhone" slot-scope="text">
                    <a-button size="small" :href="'tel:' + text.replace(/\s/, '')"><i class="fa fa-phone"
                        aria-hidden="true"></i>
                      {{ text.replace(/\s/, '').trim() }}</a-button>
                  </template>
                </a-table>
                <div slot="footer">
                  <a-pagination v-if="UserMenu != 'Rules'" size="medium" :showLessItems="true" :pageSize="10"
                    @change="fillData" :total="TotalCount" />
                </div>
              </fish-card>
            </a-col>
          </a-row>
          <a-row style='padding-top:20px;'>
            <a-col span="12" style="padding: 0 5px;">
              <div class="text-lightblue text-left">Tìm mã trúng thưởng dưới nắp chai để tham gia
                chương trình
              </div>
              <hr style="padding: 0;margin: 2px 0;">
              <div class="text-lightblue text-uppercase text-left">Thời hạn đổi thưởng:
                15/08/2026 -
                23/11/2026</div>
              <hr style="padding: 0;margin: 2px 0;">
              <div class="text-lightblue text-left">(*) Hình ảnh quà tặng chỉ mang tính chất minh họa
              </div>
            </a-col>
            <a-col span="12" style="padding: 0 5px;">
              <div class="text-lightblue text-left">NGƯỜI DƯỚI 18 TUỔI KHÔNG ĐƯỢC UỐNG RƯỢU, BIA</div>
              <div class="text-lightblue text-left">ĐÃ UỐNG RƯỢU BIA - KHÔNG LÁI XE</div>
              <div class="text-lightblue text-left">Nồng độ cồn: 4.2%</div>
              <div class="text-lightblue text-left">Liên hệ:</div>
              <div
                style="width: 130px;line-height:22px;height: 22px;text-align:center;color:green;font-weight:bold;border-top-right-radius: 250px;border-bottom-right-radius: 250px;background-color: white">
                <a style="color:#A81E22;" class="text-non-shadow" href="tel:1900638498"><i class="fa fa-phone-square"
                    aria-hidden="true"></i>
                  1900 638498</a>
              </div>
            </a-col>
          </a-row>


        </a-col>
      </div>
    </a-row>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  computed: {
  },
  mounted() {
    this.SelectMenu('Rules')
    this.fillData()
  },
  data() {
    return {
      IsConfirmAge: false,
      IsUnder18: false,
      UserMenu: "Rules",
      isLoadingTBL: false,
      TotalCount: 0,
      lstMenuData: [
        {
          Type: "Rules",
          Title: "THỂ LỆ CHƯƠNG TRÌNH",
        },
        {
          Type: "FirstPrize",
          Title: "GIẢI NHẤT",
        },
        {
          Type: "SecondPrize",
          Title: "GIẢI NHÌ",
        },
        {
          Type: "Reward",
          Title: "ĐỊA ĐIỂM ĐỔI THƯỞNG",
        },
      ],
      oMenuData: { Type: "", Title: "" },
      PrizeColumn: [
        {
          title: "STT",
          dataIndex: "STT",
          key: "STT",
          align: "center",
          scopedSlots: { customRender: "STT" },
          width: 25,
        },
        {
          title: "Ngày",
          dataIndex: "Date",
          key: "Date",
          align: "center",
          scopedSlots: { customRender: "Date" },
          width: 40,
        },
        {
          title: "Khách Hàng",
          dataIndex: "Customer",
          key: "Customer",
          align: "center",
          scopedSlots: { customRender: "customRender" },
          width: 100,
        },
        {
          title: "SĐT",
          dataIndex: "Phone",
          key: "Phone",
          align: "center",
          scopedSlots: { customRender: "Phone" },
          width: 40,
        },
        {
          title: "Khu Vực",
          dataIndex: "Location",
          key: "Location",
          align: "center",
          scopedSlots: { customRender: "customRender" },
          width: 50,
        },
      ],
      RewardColumn: [
        // {
        //   title: "Khu Vực",
        //   dataIndex: "Location",
        //   key: "Location",
        //   align: "center",
        //   scopedSlots: { customRender: "customRender" },
        //   width: 100,
        // },
        {
          title: "Tỉnh",
          dataIndex: "Province",
          key: "Province",
          align: "center",
          scopedSlots: { customRender: "customRender" },
          width: 100,
        },
        {
          title: "Điểm Đổi",
          dataIndex: "Company",
          key: "Company",
          align: "center",
          scopedSlots: { customRender: "customRender" },
          width: 170,
        },
        {
          title: "Địa Chỉ",
          dataIndex: "Address",
          key: "Address",
          align: "left",
          scopedSlots: { customRender: "Address" },
          width: 500,
        },
        // {
        //   title: "Nguời Đại Diện",
        //   dataIndex: "OwnerName",
        //   key: "OwnerName",
        //   align: "center",
        //   scopedSlots: { customRender: "OwnerName" },
        //   width: 160,
        // },
        // {
        //   title: "Điện Thoại",
        //   dataIndex: "OwnerPhone",
        //   key: "OwnerPhone",
        //   align: "center",
        //   scopedSlots: { customRender: "OwnerPhone" },
        //   width: 120,
        // },
      ],
      currentPage: 1,
      lstData: [],
      lstShow: [],
      lstSearchData: [],
      searchText: "",
      sortField: null,
      sortOrder: null,
      page: 1,
    };
  },
  methods: {

    ...mapActions(["API_GetInfo"]),
    async SelectMenu(sMenu) {
      try {
        this.isLoadingTBL = true;
        this.UserMenu = sMenu
        this.searchText = ""
        this.oMenuData = this.lstMenuData.find(st => st.Type == sMenu)
        await this.fillData()
      } catch (error) {
        console.log(error.message)
      }
      this.isLoadingTBL = false;
    },
    formatPhoneNumber(phoneNumber) {
      try {
        const cleaned = ('' + phoneNumber).replace(/\D/g, '');
        const match = cleaned.match(/^(.+)(\d{3})(\d{3})$/);
        if (match) {
          return `${match[1]} ${match[2]} ${match[3]}`;
        }
        return "";
      } catch (error) {
        return ""
      }
    },
    TestRegex(Pattern, Data) {
      try {
        Pattern = this.convertVietnameseToAscii(Pattern)
        const regex = new RegExp(Pattern, 'i'); // Case-insensitive and multiline
        Data = this.convertVietnameseToAscii(Data)
        return regex.test(Data)
      } catch (error) {
        console.log(error.message)
      }
    },
    async onChangeSearch(e) {
      this.currentPage = 1
      if (e.target.value.trim() == "") {
        this.searchText = "";
        this.lstShow = this.lstData
      }
      else {
        if (this.UserMenu.includes('Prize')) {
          this.lstSearchData = this.lstData.filter(st => this.TestRegex(this.searchText, st.Location) || this.TestRegex(this.searchText, st.Customer))
          console.log(this.lstSearchData)
          this.lstShow = this.lstSearchData
          this.TotalCount = this.lstSearchData.length
        }
        else {
          this.lstSearchData = this.lstData.filter(st => this.TestRegex(this.searchText, st.Location) || this.TestRegex(this.searchText, st.Address))
          console.log(this.lstSearchData)
          this.lstShow = this.lstSearchData
          this.TotalCount = this.lstSearchData.length
        }
      }
      await this.onChangePage(this.currentPage)
    },
    onChangePage(page) {
      this.isLoadingTBL = true;
      this.currentPage = page
      if (this.searchText.trim() != "")
        this.lstShow = this.lstSearchData.slice((this.currentPage - 1) * 10, (this.currentPage - 1) * 10 + 10);
      else
        this.lstShow = this.lstData.slice((this.currentPage - 1) * 10, (this.currentPage - 1) * 10 + 10);

      this.isLoadingTBL = false;
    },
    async fillData(Page = 1) {
      this.isLoadingTBL = true;
      try {
        this.currentPage = Page
        if (this.UserMenu == "FirstPrize") {
          this.lstData = await this.API_GetInfo("FirstPrize.json")
          this.TotalCount = this.lstData.length
        }
        else if (this.UserMenu == "SecondPrize") {
          this.lstData = await this.API_GetInfo("SecondPrize.json")
          this.TotalCount = this.lstData.length
        }
        else if (this.UserMenu == "Reward") {
          this.lstData = await this.API_GetInfo("Reward.json")
          this.TotalCount = this.lstData.length
        }
        else this.lstData = []
        this.onChangePage(this.currentPage)
      } catch (error) {
        console.log(error.message)
      }
      this.isLoadingTBL = false;
    },
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.page = pagination.current;
      this.sortField = sorter.field;
      this.sortOrder = sorter.order;
      this.fillData();
    },
    convertVietnameseToAscii(str) {
      const vietnameseMap = {
        'à': 'a', 'á': 'a', 'ạ': 'a', 'ả': 'a', 'ã': 'a', 'â': 'a', 'ầ': 'a', 'ấ': 'a', 'ậ': 'a', 'ẩ': 'a', 'ẫ': 'a',
        'è': 'e', 'é': 'e', 'ẹ': 'e', 'ẻ': 'e', 'ẽ': 'e', 'ê': 'e', 'ề': 'e', 'ế': 'e', 'ệ': 'e', 'ể': 'e', 'ễ': 'e',
        'ì': 'i', 'í': 'i', 'ị': 'i', 'ỉ': 'i', 'ĩ': 'i',
        'ò': 'o', 'ó': 'o', 'ọ': 'o', 'ỏ': 'o', 'õ': 'o', 'ô': 'o', 'ồ': 'o', 'ố': 'o', 'ộ': 'o', 'ổ': 'o', 'ỗ': 'o',
        'ù': 'u', 'ú': 'u', 'ụ': 'u', 'ủ': 'u', 'ũ': 'u', 'ư': 'u', 'ừ': 'u', 'ứ': 'u', 'ự': 'u', 'ử': 'u', 'ữ': 'u',
        'ỳ': 'y', 'ý': 'y', 'ỵ': 'y', 'ỷ': 'y', 'ỹ': 'y',
        'đ': 'd',
        'À': 'A', 'Á': 'A', 'Ạ': 'A', 'Ả': 'A', 'Ã': 'A', 'Â': 'A', 'Ầ': 'A', 'Ấ': 'A', 'Ậ': 'A', 'Ẩ': 'A', 'Ẫ': 'A',
        'È': 'E', 'É': 'E', 'Ẹ': 'E', 'Ẻ': 'E', 'Ẽ': 'E', 'Ê': 'E', 'Ề': 'E', 'Ế': 'E', 'Ệ': 'E', 'Ể': 'E', 'Ễ': 'E',
        'Ì': 'I', 'Í': 'I', 'Ị': 'I', 'Ỉ': 'I', 'Ĩ': 'I',
        'Ò': 'O', 'Ó': 'O', 'Ọ': 'O', 'Ỏ': 'O', 'Õ': 'O', 'Ô': 'O', 'Ồ': 'O', 'Ố': 'O', 'Ộ': 'O', 'Ổ': 'O', 'Ỗ': 'O',
        'Ù': 'U', 'Ú': 'U', 'Ụ': 'U', 'Ủ': 'U', 'Ũ': 'U', 'Ư': 'U', 'Ừ': 'U', 'Ứ': 'U', 'Ự': 'U', 'Ử': 'U', 'Ữ': 'U',
        'Ỳ': 'Y', 'Ý': 'Y', 'Ỵ': 'Y', 'Ỷ': 'Y', 'Ỹ': 'Y',
        'Đ': 'D'
      };

      return str.split('').map(char => vietnameseMap[char] || char).join('');
    }
  },
};
</script>
<style>
body {
  height: 100% !important;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
    Microsoft YaHei, Arial, sans-serif;

  min-height: 100% !important;
  width: 100%;
  overflow: hidden;
  background: url('~@/assets/bg.png') bottom center;
  background-size: cover;
}

.bg-bottle {
  position: fixed;
  bottom: 0;
  left: 30px;
  right: 0;
  /* width: 650px; */
  height: 100vh;
}
.bg-bottom-logo{
  position: fixed;
  bottom: 0;
  right: 0;
  min-width: 180px;
  width: 300px;
  z-index: 99999;
}
.bg-logo {
  width: 500px;
  margin-top: -40px !important;
}

.bg-tagline-mobile {
  left:0;
  margin-bottom: -40px;
  z-index: 9999;
  position: relative;
  width: 96vw;
}

.login {
  position: relative;
  width: 80%;
  max-width: 100%;
  padding: 160px 35px 0;
  margin: 0 auto;
  overflow: hidden;
}

.fish.input {
  padding-bottom: 10px !important;
}

.fish.input>i {
  top: -5px !important;
}

.fish.layout {
  height: 100% !important;
}

.menu_button {
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3), -2px -2px 5px rgba(255, 255, 255, 0.3) !important;
  height: 100% !important;
  font-size: 12px !important;
  font-weight: bold !important;
  /* font-weight: 600 !important; */
  text-transform: uppercase;
  line-height: 26px !important;
  border: 2px solid #bc193f !important;
  color: #A81E22 !important;
  padding: 0px 5px !important;
  min-width: 70px;
  transition: all 0.4s !important;
}

.menu_button:hover,
.menu_button.active {
  border: 2px solid white !important;
  color: white !important;
  background-color: #bc193f !important;
}

.confirmage_button {
  height: 100% !important;
  font-size: 1.125rem !important;
  font-weight: 600 !important;
  text-transform: uppercase;
  line-height: 40px !important;
  border: 2px solid #9c2137 !important;
  color: #9c2137 !important;
  padding: 0px 20px !important;
  min-width: 170px;
  transition: all 0.4s !important;
}

.confirmage_button:hover {
  color: white !important;
  background-color: #9c2137 !important;
  border: 2px solid white !important;
}

.agreetext {
  color: white;
  padding: 0 10px;
}

/* .row{
    margin-left: unset!important;
    margin-right: unset!important;
} */

.popup-dialog {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 9999;
  filter: alpha(opacity=0);
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
  -webkit-opacity: 0;
  -khtml-opacity: 0;
  -moz-opacity: 0;
  -ms-opacity: 0;
  -o-opacity: 0;
  opacity: 0;
  background: rgba(0, 0, 0, 0.8);
  -webkit-transition: opacity 400ms ease-in;
  -khtml-transition: opacity 400ms ease-in;
  -moz-transition: opacity 400ms ease-in;
  -ms-transition: opacity 400ms ease-in;
  -o-transition: opacity 400ms ease-in;
  transition: opacity 400ms ease-in;
  pointer-events: none;
}

.popup-dialog:target,
.popup-dialog.open {
  filter: alpha(opacity=100);
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
  -webkit-opacity: 1;
  -khtml-opacity: 1;
  -moz-opacity: 1;
  -ms-opacity: 1;
  -o-opacity: 1;
  opacity: 1;
  pointer-events: auto;
}

.right_panel {
  padding: 50px;
}

@media (min-width: 768px) {
  .popup-dialog .popup-global {
    margin: 15% auto !important;
  }
}

@media (max-width: 768px) {
  .right_panel {
    padding-top: 30px !important;
    padding: 5px !important;
  }
  .bg-bottom-logo{
    width: 50vw;
  }
  .panel_data{
    padding-bottom: 70px;
  }

}

@media (min-width:768px) {
  .bg-tagline-mobile  {
    width: 768px;
    ;
  } 
}
@media (max-width:991px) {
  .right_panel {        
    padding-top: 35% !important;
    padding: 50px;
  }

  .bg-bottle {
    width: 100vw;
    left: 0 !important;
    top: 0;
    /* padding-top: 20px; */
    height: unset !important;
  }

  .fish.card>.content {
    padding: 5px !important;
  }

  .bg-logo {
    width: 100%;
    margin-top: -20px !important;
    padding-bottom: 15px;
  }
}

.logo {
  font-family: 'FontAwesome';
  color: gold;
  font-weight: bold;
  font-size: 19px !important;
}

.fish.card>.header {
  color: #BB2125;
  font-weight: bold;
  font-size: 20px;
}

.popup-dialog .popup-global {
  margin: 50% 15px;
  position: relative;
  max-width: 600px;
  padding: 30px 40px;
  background: #dea81d;
}

.popup-dialog .close {
  font-size: 0.9375rem;
  font-weight: 500;
  color: #fff;
  width: 35px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  filter: alpha(opacity=100);
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
  -webkit-opacity: 1;
  -khtml-opacity: 1;
  -moz-opacity: 1;
  -ms-opacity: 1;
  -o-opacity: 1;
  opacity: 1;
  border-radius: 50%;
  position: absolute;
  top: -10px;
  right: -10px;
  background-color: #b30d14;
}

.popup-dialog .close:hover {
  filter: alpha(opacity=100);
  background-color: #77070d;
}

.popup-dialog .popup-global .popup--content {
  /* font-size: 1rem; */
  color: #fff;
  /* font-weight: 700; */
  line-height: 1.5;
  text-align: center;
}

.searchBox {
  width: 250px !important;
  margin-bottom: 5px !important;
}

.text-khaki {
  color: khaki !important;
}
.text-darkred {
  color: darkred !important;
}

.text-white {
  color: white !important;
}

.text-lightblue {
  font-weight: bold;
  background: linear-gradient(to bottom, 
    #EED3A9 20%,        
    #D9B57F 50%,       
    #EED3A9 80%       
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}


.text-left {
  text-align: left !important;
}

.text-non-shadow {
  text-shadow: 0 0 black !important;
}

html {
  overflow-y: overlay !important;

}
</style>
